
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoShipAddressDialog extends Serenity.EntityDialog<PoShipAddressRow, any> {
        protected getFormKey() { return PoShipAddressForm.formKey; }
        protected getIdProperty() { return PoShipAddressRow.idProperty; }
        protected getLocalTextPrefix() { return PoShipAddressRow.localTextPrefix; }
        protected getNameProperty() { return PoShipAddressRow.nameProperty; }
        protected getService() { return PoShipAddressService.baseUrl; }
        protected getDeletePermission() { return PoShipAddressRow.deletePermission; }
        protected getInsertPermission() { return PoShipAddressRow.insertPermission; }
        protected getUpdatePermission() { return PoShipAddressRow.updatePermission; }

        protected form = new PoShipAddressForm(this.idPrefix);

    }
}